/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Billing_Confirm_WaiveInputs */



/**
* | output |
* | --- |
* | "Enable & waive {amount}" |
*
* @param {Partner_Admin_Billing_Confirm_WaiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_confirm_waive = /** @type {((inputs: Partner_Admin_Billing_Confirm_WaiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Confirm_WaiveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktivieren & ${i?.amount} erlassen`)
	return /** @type {LocalizedString} */ (`Enable & waive ${i?.amount}`)
});